import React, { useEffect } from "react";
import { Navbar, Nav, Dropdown, Image } from "react-bootstrap";
// removed unused navbar icon imports
import { ICONS } from "../../constants/constants";
import "./Navbar.css";
import { FaChevronDown } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
// logo import removed (unused)
import { handleLogoutAction } from "../../store/actions/userActions";
// removed unused list actions (tenant/company data provides lists)
import { handleGetAdminData, handleGetCompanyData } from "../../store/actions/adminActions";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const AppNavbar = ({ onSidebarToggle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const { user } = useSelector((state) => state.user);

  const { adminList } = useSelector((state) => state.admin);
  const { user } = useSelector((state) => state.user);
  const userId = user?.id;
  const adminId = user?.id;
  const companyId = user?.company?.id;
  const role = user?.role;

  useEffect(() => {
    if (adminId) {
      if ((role === "admin" || role === "manager") && companyId) {
        dispatch(handleGetCompanyData(companyId)); // Fetch company data for admin/manager users
      } else if (role === "admin" || role === "manager") {
        dispatch(handleGetAdminData(adminId));
      } else if (role === "superadmin") {
        // dispatch(handleGetFarmersList()); // Fetch farmers list for superadmin
        // dispatch(handleGetSuppliersList()); // Fetch suppliers list for superadmin
        // dispatch(handleGetConsultantList());
      }
    }
  }, [dispatch, adminId, role, companyId]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId) return;
    const result = await handleLogoutAction(userId, dispatch);
    if (result) {
      // Clear the auth token from cookies
      Cookies.remove("auth-token");
      navigate("/");
    } else {
      // console.error("Logout failed");
    }
  };

  return (
    <Navbar expand="lg" className="app-navbar ">
      {/* Sidebar Toggle Icon */}
      <Navbar.Brand
        onClick={onSidebarToggle}
        className="d-flex align-items-center"
        style={{ cursor: "pointer" }}
      >
        <img src={ICONS.collapse} alt="Search" className="iconCollapser" />
        {/* <RiMenuUnfold4Fill  size={24} /> */}
      </Navbar.Brand>
      {/* Right-Aligned Navbar Items */}
      <Navbar.Toggle aria-controls="navbar-nav" />
      <Navbar.Collapse id="navbar-nav">
        <Nav className="ms-auto d-flex align-items-center">
          {/* <Nav.Link href="#" className="icon-link">
            <CiSearch className="navbar-icon innerNavicon" />
          </Nav.Link>
          <Nav.Link href="#" className="icon-link">
            <IoMdNotificationsOutline className="navbar-icon innerNavicon" />
          </Nav.Link> */}
          <Nav.Link href="#" className="icon-link">
            <img
              //src={ICONS.languageIcon}
              src={ICONS.pakistanIcon}
              alt="languages"
              className="navbar-icon innerNavicon"
            />
          </Nav.Link>
          {/* Profile Dropdown */}
          <Dropdown className="profile-drop-down" align="end">
            <Dropdown.Toggle className="profile-dropdown-toggle d-flex align-items-center">
              {/* Profile Image */}
              {user?.profileImage ? (
                <Image
                  src={user?.profile_image}
                  roundedCircle
                  alt="User profile"
                  className="profile-image"
                />
              ) : (
                <div className="user-iconNav">{user?.name?.charAt(0)}</div>
              )}

              {/* Profile Name and Role */}
              <div className="profile-details">
                <div className="prodet">
                  <strong>{user?.name || null}</strong>
                  <div className="text-muted">{user?.role || null}</div>
                  {(user?.company?.name || user?.tenant?.name) && (
                    <div className="profile-subtext text-muted">
                      {user?.company?.name || user?.tenant?.name}
                    </div>
                  )}
                </div>
                <FaChevronDown />
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="custom-dropdown-menu">
              {/* <Dropdown.Item href="/profile">Profile</Dropdown.Item> */}
              <Dropdown.Item href="/settings">Settings</Dropdown.Item>
              <Dropdown.Item href="/" onClick={handleSubmit}>
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default AppNavbar;
